module.exports = __webpack_public_path__ + "static/media/chevron-close.99eca5c1.svg";